import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  getVouchers,
  deleteVoucher,
  getAllFinanceEmployees,
  generateVouchersPaymentListingPDF,
} from "../../services/apiPayment";
import { getAllVendors } from "../../services/apiSettings";
import { Box, Typography, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Addvoucher from "./AddVoucher";
import ViewVoucher from "./ViewVoucher";
import "../../css/payment.css";
import Swal from "sweetalert2";
import PopUp from "../PopUp";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Select from "react-select";
import Loader from "../Loader";
const VendorVouchers = () => {
  const Group = require("../../assets/images/payments.png");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      height: "30px !important",
      minWidth: "200px !important",
      marginTop: "12px",
      borderRadius: "0.375rem",
      borderColor: "#dee2e6",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#dee2e6",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      marginTop: "2px", // Reduced spacing between select and dropdown
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#0d6efd"
        : state.isFocused
          ? "#e9ecef"
          : "white",
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
      fontSize: "13px", // Option font size
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "13px",
      color: "#000000", // Black color for placeholder
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "13px",
      color: "#000000",
    }),
    input: (provided) => ({
      ...provided,
      fontSize: "13px",
      color: "#000000",
    }),
  };
  const [vendorList, setVendorList] = useState([]);
  const [selectedVendorid, setSelectedVendorid] = useState("");
  const [open, setOpen] = useState(false);
  const [viewopen, setviewOpen] = useState(false);
  const [voucherlist, setVoucherList] = useState([]);
  const [period, setPeriod] = useState("");
  const [inputFilterDate, setFilterDate] = useState("");
  const [FilterName, setFilterName] = useState("");
  const [FilterValue, setFilterValue] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [message, setMessage] = useState("");
  const [openPopUp, setOpenPopUp] = useState(false);
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const { vendorId } = location.state || {};
  const [EmployeeList, setEmployeeList] = useState([]);
  const [employeeId, setEmployeeId] = useState("");

  const fetchVendorList = async () => {
    try {
      const listvendors = await getAllVendors();
      setVendorList(listvendors?.vendors || []);
    } catch (error) {
      console.log("Cannot fecth vendor", error);
    }
  };

  useEffect(() => {
    fetchVendorList();
    if (vendorId) setSelectedVendorid(vendorId);
    let payload = {
      vendorId: vendorId,
      paymentDate: "",
      filter: "",
      employeeId: "",
    };
    fetchVouchers(payload);
  }, [vendorId]);

  const fetchVouchers = async (payload) => {
    try {
      const Listvouchers = await getVouchers(payload);
      setVoucherList(Listvouchers?.vouchers || []);
    } catch (error) {
      console.log("Error in Api", error);
    }
  };

  const handleListVouchers = (payload) => {
    setEditMode(false);
    fetchVouchers(payload);
    setOpen(false);
  };

  const [selectedMonth, setSelectedMonth] = useState();

  const handleTimeperiod = async (e) => {
    let payload = "";
    const SelectBxname = e.target.name;
    if (e.target.name == "month") {
      setSelectedMonth(e.target.value);
    }
    if (SelectBxname === "search-voucher-date") {
      setPeriod("");
      setFilterDate(e.target.value);
      payload = { vendorId: selectedVendorid, paymentDate: e.target.value };
    } else {
      setFilterDate("");
      setFilterName(SelectBxname);
      setFilterValue(e.target.value);
      payload = {
        vendorId: selectedVendorid,
        paymentDate: "",
        filter: SelectBxname,
        [SelectBxname]: e.target.value,
        employeeId: employeeId,
      };
    }
    fetchVouchers(payload);
  };

  const handleEmployeeChange = (e) => {
    setEmployeeId(e.target.value);
    let payload = {
      vendorId: selectedVendorid,
      paymentDate: inputFilterDate,
      filter: FilterName,
      [FilterName]: FilterValue,
      employeeId: e.target.value,
    };
    console.log(payload, "payload_handleEmployeeChange");
    fetchVouchers(payload);
  };

  const OpenDialog = () => {
    handClickOpen();
  };
  const handClickOpen = () => {
    setOpen(true);
  };
  const resetErrors = () => {
    setErrors({});
  };
  const handleClose = () => {
    setOpen(false);
    resetErrors();
    setSelectedRow(null);
    setEditMode(false);
  };
  const handleView = (row) => {
    setSelectedRow(row);
    openViewDialog();
  };
  const openViewDialog = () => {
    handleClickOpenView();
  };
  const handleClickOpenView = () => {
    setviewOpen(true);
  };

  const handleCloseView = () => {
    setviewOpen(false);
    setSelectedRow(null);
  };

  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  // Generate an array of years (e.g., 2000 to 2030)
  const startYear = 2020;
  const currentYear = new Date().getFullYear();

  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => startYear + index,
  );
  let payloadParams = "";
  if (FilterName === "")
    payloadParams = {
      vendorId: selectedVendorid,
      paymentDate: inputFilterDate,
      filter: "",
      employeeId: employeeId,
    };
  else
    payloadParams = {
      vendorId: selectedVendorid,
      paymentDate: inputFilterDate,
      filter: FilterName,
      [FilterName]: FilterValue,
      employeeId: employeeId,
    };
  const handleDelete = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (item?._id) {
          try {
            let payload = {
              pettyId: item?._id,
            };
            const response = await deleteVoucher(payload);
            setMessage(response.message);
            setOpenPopUp(true);
            fetchVouchers(payloadParams);
          } catch (error) {
            Swal.fire("Error deleting payments");
            fetchVouchers(payloadParams);
          }
        }
      }
    });
  };
  const handleEdit = (row) => {
    setSelectedRow(row);
    setEditMode(true);
    OpenDialog();
  };

  const NoRowsOverlay = () => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        color: "gray",
      }}
    >
      <Typography>No Record Found</Typography>
    </Box>
  );

  const columns = [
    // { field: "quotation", headerName: "Quotation Number", flex: 3,minWidth:150 },
    { field: "voucher", headerName: "Petty Number", flex: 2, minWidth: 130 },
    { field: "throughs", headerName: "Through", flex: 3 },
    { field: "particulars", headerName: "Particulars", flex: 3 },
    { field: "accountof", headerName: "On Account of", flex: 3 },
    { field: "vendorName", headerName: "Vendor Name", flex: 3 },
    { field: "dateofPay", headerName: "Payment Date", flex: 2, minWidth: 130 },
    { field: "amount", headerName: "Amount", flex: 2 },
    { field: "remark", headerName: "Remark", flex: 2 },
    // {
    //   field: "modeofPayment",
    //   headerName: "Mode of Payment",
    //   flex: 3,
    //   minWidth: 100,
    // },
    // { field: "banks", headerName: "Bank", flex: 2 },
    {
      field: "actions",
      headerName: "Action",
      flex: 5,
      renderCell: (params) => {
        console.log("params", params);
        // Use isVendorPetty to determine button visibility
        const isVendorPetty = params.row.isVendorPetty === true;

        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              className="btn btna submitpaymentbutton btnfsize"
              onClick={() => handleView(params.row)}
              style={{ marginRight: "8px" }}
            >
              View
            </button>
            {!isVendorPetty && (
              <>
                <IconButton
                  color="primary"
                  onClick={() => handleEdit(params.row)}
                >
                  <EditIcon sx={{ fontSize: "19px" }} />
                </IconButton>
                <IconButton
                  color="secondary"
                  onClick={() => handleDelete(params.row)}
                >
                  <DeleteIcon sx={{ fontSize: "19px" }} />
                </IconButton>
              </>
            )}
          </div>
        );
      },
    },
  ];

  const fetchFinaceEmployees = async () => {
    try {
      const listemployees = await getAllFinanceEmployees();
      setEmployeeList(listemployees?.employees || []);
    } catch (error) {
      console.log("Employee list Error", error);
    }
  };

  useEffect(() => {
    fetchFinaceEmployees();
  }, []);

  const getPDF = async () => {
    let payload = {
      vendorId: selectedVendorid,
      paymentDate: inputFilterDate,
      employeeId: employeeId,
      filter: FilterName,
      month: selectedMonth ? selectedMonth : "",
    };
    setIsLoading(true);

    console.log(payload, "payload_getReport");
    try {
      const response = await generateVouchersPaymentListingPDF(payload);
      console.log("getPettyCashReport", response);

      if (response?.pdfPath) {
        const pdfUrl = `${process.env.REACT_APP_ASSET_URL}${response.pdfPath}`;
        // Fetch the PDF as a Blob
        const pdfResponse = await fetch(pdfUrl);
        const pdfBlob = await pdfResponse.blob();
        const pdfBlobUrl = URL.createObjectURL(pdfBlob);
        // Create a hidden anchor tag to trigger the download
        const link = document.createElement("a");
        link.href = pdfBlobUrl;
        link.setAttribute("download", "Petty Cash Payments.pdf"); // Set the file name
        document.body.appendChild(link);
        link.click();
        // Clean up
        document.body.removeChild(link);
        URL.revokeObjectURL(pdfBlobUrl);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch quotations:", error);
      setIsLoading(false);
    }
  };

  const createExcel = async () => {
    if (!voucherlist || voucherlist.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Data",
        text: "No vouchers available to export",
      });
      return;
    }

    // Prepare data for Excel
    const excelData = voucherlist.map((item) => {
      const dateOnly = item.paymentDate
        ? item.paymentDate.split("T")[0]
        : "N/A";
      const [year, month, day] = dateOnly.split("-");
      const formattedDate = `${day}-${month}-${year}`;

      return {
        "Petty Number": item.voucherNumber || "N/A",
        Through: item.through && item.through.name ? item.through.name : "N/A",
        Particulars: item.voucherParticulers || "N/A",
        "On Account of": item.voucherAccount || "N/A",
        "Vendor Name": item.vendorId?.vendorName || "N/A",
        "Payment Date": formattedDate || "N/A",
        Amount: item.amount || "N/A",
        Remark: item.remark || "N/A",
      };
    });

    const headers = Object.keys(excelData[0]);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Petty Cash Payments", {
      properties: { defaultRowHeight: 18 },
      pageSetup: { fitToPage: true, fitToWidth: 1, fitToHeight: 0 },
    });

    // Header
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFEFEFEF" },
      };
    });

    // Data rows
    excelData.forEach((data) => {
      const dataRow = worksheet.addRow(headers.map((h) => data[h]));

      // Calculate height for "On Account of" column content
      const accountOfContent = data["On Account of"] || "";
      const accountOfLength = accountOfContent.toString().length;

      // Estimate lines needed for "On Account of" column (50 characters per line)
      const estimatedLines = Math.max(1, Math.ceil(accountOfLength / 50));

      // Set row height based on content (minimum 18, add 18 points per additional line)
      const calculatedHeight = Math.max(18, 18 * estimatedLines);
      dataRow.height = Math.min(calculatedHeight, 200); // Cap at 200 points

      dataRow.eachCell((cell) => {
        cell.alignment = {
          horizontal: "center",
          vertical: "top",
          wrapText: true,
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    // Auto-size columns with special handling for "On Account of"
    const minWidth = 15;
    const maxWidth = 60;
    headers.forEach((h, i) => {
      if (h === "On Account of" || h === "Particulars") {
        // Set fixed width for columns that need wrapping
        worksheet.getColumn(i + 1).width = 50;
      } else {
        let maxLen = (h || "").toString().length;
        excelData.forEach((data) => {
          const val = data[h];
          const len = val == null ? 0 : val.toString().length;
          if (len > maxLen) maxLen = len;
        });
        const width = Math.max(minWidth, Math.min(maxWidth, maxLen + 2));
        worksheet.getColumn(i + 1).width = width;
      }
    });

    // Set view options to ensure proper display when opened
    worksheet.views = [
      {
        state: "normal",
        showGridLines: true,
        showRowColHeaders: true,
        rightToLeft: false,
      },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const fileName = "Petty Cash Payments.xlsx";

    saveAs(blob, fileName);
  };

  const vendorOptions = vendorList.map((vendor) => ({
    value: vendor._id,
    label: vendor.vendorName,
  }));

  const handleVendorSelectChange = (selectedOption) => {
    const vendorId = selectedOption ? selectedOption.value : "";
    setSelectedVendorid(vendorId);

    // If no vendor selected, do NOT call API
    if (!vendorId) return;

    let payload = {
      vendorId: vendorId ? vendorId : selectedVendorid,
      paymentDate: inputFilterDate,
      filter: FilterName,
      [FilterName]: FilterValue,
      employeeId: employeeId,
    };

    fetchVouchers(payload);
  };

  return (
    <>
      <div>
        <div className=" mt-3 d-flex align-items-center">
          <div className=" d-flex paymentbycus">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label filterbypayment "
            >
              {" "}
              Vendor:
            </label>
            <div className="vessel-select">
              <Select
                options={vendorOptions}
                onChange={handleVendorSelectChange}
                value={vendorOptions.find(
                  (opt) => opt.value === selectedVendorid,
                )}
                placeholder="Choose Vendor Name"
                isClearable
                isSearchable
                styles={customSelectStyles}
                className="paymentcustomer"
                classNamePrefix="react-select"
              />
            </div>
          </div>
          <div className=" d-flex paymentbycus">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label filterbypayment "
            >
              {" "}
              Employee:
            </label>
            <div className="vessel-select">
              <select
                name="through"
                className="form-select vesselbox"
                aria-label="Default select example"
                onChange={handleEmployeeChange}
                value={employeeId}
                style={{ height: "38px" }}
              >
                <option value="">Choose Employee</option>
                {EmployeeList.map((emp) => (
                  <option key={emp._id} value={emp._id}>
                    {`${emp.name}_Petty`}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="cusbydate">
            <label
              htmlFor="inputPassword"
              className=" col-form-label text-nowrap paymedatepaymentpage"
            >
              Payment Date:
            </label>
            <div className="">
              <div className="fw-bolder paymentpdafontweight"></div>
            </div>
          </div>
          <div className="">
            {/*<i className="bi bi-funnel-fill filtericon"></i>*/}
            <input
              type="date"
              name="search-voucher-date"
              className="datebycustomerpayment form-control vesselbox statusspayment"
              placeholder="Select Date"
              onChange={handleTimeperiod}
              value={inputFilterDate}
            ></input>
          </div>
          <div className=" d-flex filterpayment">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label filterbypayment "
            >
              {" "}
              Filter By:
            </label>
            <div className="vessel-select">
              <select
                name="status"
                className="form-select vesselbox statussbycustomer"
                style={{ height: "38px" }}
                onChange={(e) => setPeriod(e.target.value)}
                value={period}
              >
                <option value="">Select Period</option>
                <option value="month">Monthly</option>
                <option value="year">Yearly</option>
              </select>
            </div>
          </div>

          <div className=" d-flex filterpayment">
            {period === "month" && (
              <select
                name="month"
                className="form-select jobporrt mmonthpayment monthcustomerpay"
                onChange={handleTimeperiod}
                style={{ height: "38px" }}
              >
                <option value="">Select Month</option>
                {months.map((month, index) => (
                  <option key={index} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            )}

            {period === "year" && (
              <select
                name="year"
                className="form-select vesselbox yearlist mmonth monthcustomerpay"
                onChange={handleTimeperiod}
                style={{ height: "38px" }}
              >
                <option value="">Select Year</option>
                {years.map((year, index) => (
                  <option key={index} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            )}
          </div>
          <button
            className="btn btn-info filbtnjob align-items-center"
            onClick={() => {
              getPDF();
            }}
          >
            Download PDF
          </button>
          <button
            className="btn btn-info filbtnjob ms-2 align-items-center"
            onClick={createExcel}
          >
            Download Excel
          </button>
        </div>

        <div className="charge">
          <div className="rectangle"></div>
          <div>
            <img src={Group}></img>
          </div>
        </div>

        <Addvoucher
          open={open}
          onClose={handleClose}
          vendorId={selectedVendorid}
          ListVouchers={handleListVouchers}
          editMode={editMode}
          prevVouchers={selectedRow}
          errors={errors}
          setErrors={setErrors}
        />
        <ViewVoucher
          open={viewopen}
          onClose={handleCloseView}
          getvoucher={selectedRow}
        />

        <div className="voucheramount marginvoucher">
          {/*<div className=" d-flex" >
       <div className="totalinvocie"> Total Invoice Amount:</div> <div className="amountpayment"> ${totalInvoiceAmount} </div>
      </div>
      <div className=" d-flex" >
       <div className="totalinvocie"> Paid Amount:</div> <div className="amountpayment"> ${paidAmount} </div>
      </div>
      <div className=" d-flex" >
       <div className="totalinvocie"> Balance Amount:</div> <div className="amountpayment"> ${balanceAmount} </div>
      </div>
      <div className=" ">
      <button
        type="button"
        className="btn btn-info infobtn"
      >
        Add Voucher
      </button>
    </div>
    <div className=" paymentbtn">
      <button
        type="button"
        className="btn btn-info infobtn"
      >
       View Voucher
      </button>
    </div>*/}
          <div className="d-flex ">
            <button
              onClick={() => {
                OpenDialog();
              }}
              className="btn btn-info filbtnjob"
            >
              Add Petty
            </button>
          </div>
        </div>

        <DataGrid
          rows={voucherlist.map((item) => {
            // Check if item.pdaIds is an array and contains objects

            const dateOnly = item.paymentDate
              ? item.paymentDate.split("T")[0]
              : "N/A";
            const [year, month, day] = dateOnly.split("-");
            const formattedDate = `${day}-${month}-${year}`;
            let modeofpay = "";
            if (item.modeofPayment !== undefined)
              modeofpay =
                item.modeofPayment.charAt(0).toUpperCase() +
                item.modeofPayment.slice(1);

            return {
              ...item,
              id: item._id,
              //quotation:item.pdaIds ? item.pdaIds.pdaNumber : "N/A",
              voucher: item.voucherNumber || "N/A",
              throughs:
                item.through && item.through.name ? item.through.name : "N/A",
              particulars: item.voucherParticulers || "N/A",
              accountof: item.voucherAccount || "N/A",
              dateofPay: formattedDate || "N/A",
              amount: item.amount || "N/A",
              vendorId: item.vendorId?._id || "",
              vendorName: item.vendorId?.vendorName || "N/A",
              remark: item.remark || "N/A",
              // modeofPayment: modeofpay || "N/A",
              // banks:
              //   item.bank && item.bank.bankName ? item.bank.bankName : "N/A",
            };
          })}
          columns={columns}
          getRowId={(row) => row._id} // Use id field for unique row identification
          disableSelectionOnClick // Disables checkbox selection to prevent empty column
          disableColumnMenu // Removes column menu
          components={{
            NoRowsOverlay,
          }}
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#eee !important", // Set gray background color
              color: "#000000", // Set white text color for contrast
              fontWeight: "bold", // Optional: Make the text bold
            },
            "& .MuiDataGrid-cell": {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
            "& .MuiTablePagination-toolbar": {
              alignItems: "baseline", // Apply align-items baseline
            },
            "& .MuiDataGrid-columnHeaderTitle": { fontWeight: "bold" },
            "& .MuiDataGrid-footerContainer": {
              backgroundColor: "#eee", // Gray background for the footer
            },
          }}
          pagination // Enables pagination
          pageSizeOptions={[5, 10, 20, 50, 100]} // Sets available page size options
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10, // Default page size
                page: 0, // Default page index
              },
            },
          }}
        />
        {voucherlist?.length === 0 && (
          <div className="no-data">
            <p>No Data Found</p>
          </div>
        )}
      </div>

      {openPopUp && (
        <PopUp message={message} closePopup={() => setOpenPopUp(false)} />
      )}
      <Loader isLoading={isLoading} />
    </>
  );
};

export default VendorVouchers;
